import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

function OrganismSelect({ options, value, onChange, disabled }) {
  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id="organism-select-label">Organism</InputLabel>
      <Select
        labelId="organism-select-label"
        id="organism-select"
        value={value ?? ''}
        label="Organism"
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <MenuItem key={option.name} value={option.name}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

OrganismSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    latestCompletedAt: PropTypes.string
  })).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

OrganismSelect.defaultProps = {
  value: null,
  disabled: false
};

export default OrganismSelect;
